import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Google",
  "use": "icon-Google-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Google\"><path d=\"M1000 523.6C1000 806.6 806.2 1008 520 1008 245.6 1008 24 786.4 24 512S245.6 16 520 16c133.6 0 246 49 332.6 129.8l-135 129.8C541 105.2 212.6 233.2 212.6 512c0 173 138.2 313.2 307.4 313.2 196.4 0 270-140.8 281.6-213.8H520v-170.6h472.2c4.6 25.4 7.8 49.8 7.8 82.8z\" p-id=\"11193\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol